import { atom } from 'jotai';

export const showMenuAtom = atom<boolean>(false);
